import scanner from 'onscan.js';
import React, { FC, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormGrid, Page } from '../../../shared';
import { StartRegistrationInfo } from '../../components/start-registration/start-registration-info.component';
import { StartRegistrationQrCode } from '../../components/start-registration/start-registration-qr-code.component';
import { StartRegistrationSearch } from '../../components/start-registration/start-registration-search.component';
import { StartRegistrationNationalSecurityNumber } from '../../components/start-registration/start-registration-national-security-number.component';

export const StartRegistrationPage: FC = () => {
    const navigate = useNavigate();

    const onScan = useCallback(
        (scanned: string) => {
            let parsedCode = scanned?.replace(/-/g, '');
            if (parsedCode?.startsWith('SDVH') && parsedCode.length > 8) parsedCode = parsedCode.replace('SDVH', '');
            const formattedCode = [parsedCode?.slice(0, 4), parsedCode?.slice(4)].join('-');
            setTimeout(() => {
                navigate(`/registration/info?code=${formattedCode}`);
            });
        },
        [navigate],
    );

    useEffect(() => {
        scanner.attachTo(document, { onScan });
        return () => scanner.detachFrom(document);
    }, [onScan]);

    return (
        <Page>
            <FormGrid
                size={{ sm: 12, md: 6 }}
                containerProps={{ alignItems: 'stretch', spacing: 3, m: 1 }}
                itemProps={{
                    '.MuiSvgIcon-root': { fontSize: 80 },
                    '.MuiCard-root': { p: 2 },
                    '.MuiStack-root': { height: '100%', width: '350px', m: 'auto' },
                }}
            >
                <StartRegistrationInfo />
                <StartRegistrationQrCode />
                <StartRegistrationNationalSecurityNumber />
                <StartRegistrationSearch />
            </FormGrid>
        </Page>
    );
};
